"use client";

import { useEffect } from "react";
import { track } from "@/lib/observability/analytics";

/**
 * Emet un event `physician:viewed` cote client au mount.
 *
 * Pourquoi cote client (vs trackPageView server-side) :
 * - trackPageView ecrit en DB locale (TrackEvent) pour analytics interne
 * - physician:viewed envoie a GA4/Plausible/PostHog pour funnels externes
 *
 * Sans cet event, GA4 affichait page_view (generique) mais aucun signal
 * specifique d'engagement fiche medecin. Audit GA4 2026-06-19 :
 * physician:viewed declare dans SahhaEvent type mais 0 events tracked
 * (jamais appele).
 *
 * useEffect [] (mount only) pour eviter de re-emettre sur scroll/state
 * change. Le dedup par session est gere par GA4 cote serveur.
 */
type Props = {
  physicianSlug: string;
  specialty?: string | null;
  city?: string | null;
  tier?: string | null;
  verified?: boolean;
  isCenter?: boolean;
};

export function PhysicianViewedTracker({
  physicianSlug,
  specialty,
  city,
  tier,
  verified,
  isCenter,
}: Props) {
  useEffect(() => {
    track("physician:viewed", {
      physicianSlug,
      specialty: specialty || undefined,
      city: city || undefined,
      tier: tier || undefined,
      verified: Boolean(verified),
      isCenter: Boolean(isCenter),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
